const SHOP_DATA = [
  {
    id: 1,
    title: "Organic Foods",
    routeName: "foods",
    items: [
      {
        id: 2,
        name: "Food Item 1",
        imageUrl:
          "https://cdn.pixabay.com/photo/2017/04/23/09/44/smoothies-2253423_1280.jpg",
        price: 25,
      },
      {
        id: 3,
        name: "Food Item 2",
        imageUrl:
          "https://cdn.pixabay.com/photo/2010/12/13/10/05/background-2277_1280.jpg",
        price: 25,
      },
      {
        id: 4,
        name: "Food Item 3 ",
        imageUrl:
          "https://cdn.pixabay.com/photo/2017/07/27/17/38/fruits-2546119_1280.jpg",
        price: 25,
      },
      {
        id: 5,
        name: "Food Item 4",
        imageUrl:
          "https://cdn.pixabay.com/photo/2017/06/02/18/16/glasses-2367017_960_720.jpg",
        price: 25,
      },
      {
        id: 6,
        name: "Food Item 5",
        imageUrl:
          "https://cdn.pixabay.com/photo/2017/07/27/00/27/delicious-meal-2543640_1280.jpg",
        price: 25,
      },
      {
        id: 7,
        name: "Food Item 6",
        imageUrl:
          "https://cdn.pixabay.com/photo/2017/07/27/17/52/blueberries-2546157_1280.jpg",
        price: 25,
      },
    ],
  },

  {
    id: 8,
    title: "Cosmetics",
    routeName: "cosmetics",
    items: [
      {
        id: 9,
        name: "Item 1",
        imageUrl:
          "https://cdn.pixabay.com/photo/2016/06/25/12/48/glasess-1478812_1280.jpg",
        price: 25,
      },
      {
        id: 10,
        name: "Item 2 ",
        imageUrl:
          "https://cdn.pixabay.com/photo/2016/07/26/16/48/cosmetics-1543276_1280.jpg",
        price: 25,
      },
      {
        id: 11,
        name: "Item 3",
        imageUrl:
          "https://cdn.pixabay.com/photo/2016/12/30/21/28/make-up-1941573_960_720.jpg",
        price: 25,
      },
      {
        id: 12,
        name: "Item 4",
        imageUrl:
          "https://cdn.pixabay.com/photo/2016/02/19/11/35/make-up-1209798_1280.jpg",
        price: 25,
      },
      {
        id: 13,
        name: "Gray Hat",
        imageUrl: "",
        price: 25,
      },
      {
        id: 14,
        name: "No Hat",
        imageUrl: "",
        price: 25,
      },
    ],
  },

  {
    id: 15,
    title: "Cars",
    routeName: "cars",
    items: [
      {
        id: 16,
        name: "Car 1",
        imageUrl:
          "https://cdn.pixabay.com/photo/2016/02/13/13/11/cuba-1197800_1280.jpg",
        price: 25,
      },
      {
        id: 17,
        name: "Car 2",
        imageUrl:
          "https://cdn.pixabay.com/photo/2015/05/28/23/12/auto-788747_1280.jpg",
        price: 25,
      },
      {
        id: 18,
        name: "Car 3",
        imageUrl:
          "https://cdn.pixabay.com/photo/2014/10/22/17/22/ford-498244_1280.jpg",
        price: 25,
      },
      {
        id: 19,
        name: "Car 4",
        imageUrl:
          "https://cdn.pixabay.com/photo/2016/02/13/13/11/cuba-1197800_1280.jpg",
        price: 25,
      },
      {
        id: 20,
        name: "Gray Hat",
        imageUrl: "",
        price: 25,
      },
      {
        id: 21,
        name: "No Hat",
        imageUrl: "",
        price: 25,
      },
    ],
  },

  {
    id: 22,
    title: "Gift Corner",
    routeName: "gifts",
    items: [
      {
        id: 23,
        name: "Gift 1",
        imageUrl:
          "https://cdn.pixabay.com/photo/2014/08/29/23/08/toy-car-431356_1280.jpg",
        price: 25,
      },
      {
        id: 24,
        name: "Gift 2",
        imageUrl:
          "https://cdn.pixabay.com/photo/2017/02/11/14/19/valentines-day-2057745_1280.jpg",
        price: 25,
      },
      {
        id: 25,
        name: "Gift 3",
        imageUrl:
          "https://cdn.pixabay.com/photo/2017/11/24/20/01/christmas-cookies-2975570_1280.jpg",
        price: 25,
      },
      {
        id: 26,
        name: "Gift 4",
        imageUrl:
          "https://cdn.pixabay.com/photo/2018/08/11/22/53/teddy-bear-3599680_1280.jpg",
        price: 25,
      },
      {
        id: 27,
        name: "Gray Hat",
        imageUrl: "",
        price: 25,
      },
      {
        id: 28,
        name: "No Hat",
        imageUrl: "",
        price: 25,
      },
    ],
  },
];

export default SHOP_DATA;
